var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2978",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8014 0.938477H0.198242V20.9385H19.8014V0.938477Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8008 11.1677C19.8008 10.4879 19.7457 9.80449 19.6281 9.13574H10.1958V12.9866H15.5972C15.3731 14.2285 14.6529 15.3272 13.5983 16.0253V18.5239H16.8208C18.7132 16.7822 19.8008 14.2102 19.8008 11.1677Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.197 20.9383C12.894 20.9383 15.1686 20.0527 16.8256 18.5241L13.6032 16.0255C12.7066 16.6355 11.5492 16.9809 10.2007 16.9809C7.59181 16.9809 5.3798 15.2208 4.58612 12.8545H1.26074V15.4302C2.95834 18.8072 6.416 20.9383 10.197 20.9383Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58125 12.8543C4.16236 11.6123 4.16236 10.2675 4.58125 9.0255V6.44971H1.25955C-0.158783 9.27536 -0.158783 12.6044 1.25955 15.43L4.58125 12.8543Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.197 4.89555C11.6227 4.87351 13.0006 5.40997 14.0331 6.39473L16.8881 3.53967C15.0804 1.84209 12.6809 0.908778 10.197 0.938174C6.41598 0.938174 2.95834 3.06935 1.26074 6.44984L4.58244 9.02563C5.37244 6.6556 7.58813 4.89555 10.197 4.89555Z",
    fill: "#EA4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8d06121a.svg";
export { ForwardRef as ReactComponent };